module.exports = __webpack_public_path__ + "static/media/Teresa Conte Headshot_1608088356141.2f4211fd.jpg";